<template>
  <div class="box">
    <table class="table is-fullwidth" v-show="!loading && docs.length > 0">
      <thead>
        <tr>
          <th>Employee ID</th>
          <th>Name</th>
          <th>Mobile</th>
          <th>Email</th>
          <th>Role</th>
          <th>Active</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in docs" :key="user._id">
          <td>{{ user.employeeId }}</td>
          <td>{{ user.name }}</td>
          <td>{{ user.mobile }}</td>
          <td>{{ user.email }}</td>
          <td>
            <span
              class="is-uppercase"
              :class="{'has-text-danger': user.role === 'admin'}"
            >{{ user.role }}</span>
          </td>
          <td>
            <span
              class="is-uppercase"
              :class="{'has-text-success': user.active}"
            >{{ user.active ? 'Active' : 'Inactive' }}</span>
          </td>
          <td class="actions">
            <router-link :to="`/user/view/${user._id}`">View</router-link>
            <router-link :to="`/user/edit/${user._id}`">Edit</router-link>
            <router-link :to="`/user/delete/${user._id}`" class="has-text-danger">Delete</router-link>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="has-text-centered">
      <button class="button is-loading is-large" v-show="loading"></button>
      <p
        class="has-text-grey"
        v-show="!loading && docs.length === 0"
      >No records matching these criteria</p>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    docs() {
      let component = this;
      return component.$store.getters["user/docs"];
    },
    loading() {
      let component = this;
      return component.$store.getters["user/loading"];
    }
  },
  mounted() {
    let component = this;
    component.$store.dispatch("user/index");
  }
};
</script>
<style lang="scss" scoped>
.actions {
  a {
    padding-right: 16px;
  }
}
button.is-loading {
  border: none;
}
</style>